import { useSelector } from 'react-redux';
import { featureSelector, getUserProfile } from '@store/common/selectors';
import { useAtomValue } from 'jotai';
import { USER_ROLE_READONLY } from '@utils/constants';
import { useResetAtom } from 'jotai/utils';
import { DataSource } from '../utils';
import * as atoms from './atom';

export const useResetState = () => {
  const resetFilterCreate = useResetAtom(atoms.filterCreate);
  const resetFilterEditor = useResetAtom(atoms.filterEditor);
  const resetFilterClone = useResetAtom(atoms.filterClone);

  const reset = () => {
    resetFilterCreate();
    resetFilterEditor();
    resetFilterClone();
  };

  return {
    reset,
    resetFilterCreate,
    resetFilterEditor,
    resetFilterClone,
  };
};

export const useFilterPanelVisible = () => {
  const filterCreate = Boolean(useAtomValue(atoms.filterCreate));
  const filterEditor = Boolean(useAtomValue(atoms.filterEditor));
  const filterClone = Boolean(useAtomValue(atoms.filterClone));
  return {
    isVisible: filterCreate || filterEditor || filterClone,
    isFilterCreateVisible: filterCreate,
    isFilterEditorVisible: filterEditor,
    isFilterCloneVisible: filterClone,
  };
};

export const useReadOnlyRole = () => {
  const user = useSelector(getUserProfile);
  return user.role === USER_ROLE_READONLY;
};

export const useDrilldownLimit = (dataSource: DataSource) => {
  const isApp = dataSource === DataSource.app;
  // controll the maximum count of rules that can be created
  // const appDrilldownLimit = useSelector(featureSelector('app-drilldown-limit')) as number;

  return isApp ? 50 : 900;
};

export const useAllowCreateFilter = (dataSource: DataSource) => {
  const isApp = dataSource === DataSource.app;
  // controll if allow user to create & clone filter
  const allowCreateFilter = useSelector(
    featureSelector(isApp ? 'app-create-filter' : 'create-filter'),
  ) as boolean;
  return allowCreateFilter ?? true;
};
